import { Apis } from "../../lib/Apis";

export const useFrontElevation = () => {
  const getFrontElevation = async (setFrontElevationData) => {
    try {
      const response = await Apis.getFrontElevation();
      setFrontElevationData(response.data.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching front elevation:", error);
      throw error;
    }
  };

  const getFrontElevationWithPagination = async (page = 0, limit = 10, setFrontElevationData, setPaginationInfo) => {
    try {
      console.log(page, limit);
      const response = await Apis.getFrontElevationWithPagination(page, limit);
      setFrontElevationData(response.data.data);
      if (setPaginationInfo) {
        setPaginationInfo(response.data.pagination);
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching front elevation with pagination:", error);
      throw error;
    }
  };

  const addFrontElevation = async (data) => {
    try {
      const response = await Apis.addFrontElevation(data);
      return response.data;
    } catch (error) {
      console.error("Error adding front elevation:", error);
      throw error;
    }
  };

  const updateFrontElevation = async (id, data) => {
    try {
      const response = await Apis.updateFrontElevation(id, data);
      return response.data;
    } catch (error) {
      console.error("Error updating front elevation:", error);
      throw error;
    }
  };

  const deleteFrontElevation = async (id) => {
    try {
      const response = await Apis.deleteFrontElevation(id);
      return response.data;
    } catch (error) {
      console.error("Error deleting front elevation:", error);
      throw error;
    }
  };
  const getFrontElevationById = async (id, setFrontElevationData) => {
    try {
      const response = await Apis.getFrontElevationById(id);
      setFrontElevationData(response.data)
      return response.data;
    } catch (error) {
      console.error("Error fetching front elevation by id:", error);
      throw error;
    }
  };

  return { getFrontElevation, getFrontElevationWithPagination, addFrontElevation, updateFrontElevation, deleteFrontElevation, getFrontElevationById };
};
